import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Grid, TextField } from '@material-ui/core';
import { IsEmpty } from '../../../common/checks';

const TermsSource = (props) => {
  const [validUrl, setValidUrl] = useState(false);

  const onChange = (e) => {
    switch (e.target.name) {
      case 'terms':
        props.onTermsChanged(e.target.value);
        break;
      case 'source': {
        const source = e.target.value;
        if (!IsEmpty(source) && source.indexOf('http://') !== 0 && source.indexOf('https://') !== 0) {
          props.onSourceChanged(source);
          setValidUrl(true);
        } else {
          setValidUrl(false);
          props.onSourceChanged(source);
        }
        break;
      }
      default:
    }
  };

  return (
    <Grid container direction="column" spacing={3}>
      <Grid item>
        <h5>Specify terms &amp; conditions (if any)</h5>
        <TextField name="terms" multiline className="d-flex" value={props.terms} onChange={(e) => onChange(e)} />
      </Grid>

      <Grid item>
        <h5>Source of promotion</h5>
        {
          validUrl
            ? (
              <p style={{ color: 'red' }}>
                Invalid url
                <br />
                <small style={{ color: 'gray' }}>Must start with http:// or https://</small>
              </p>
            )
            : null
        }
        <TextField name="source" multiline className="d-flex" value={props.source} onChange={(e) => onChange(e)} />
      </Grid>
    </Grid>
  );
};

TermsSource.defaultProps = {
  source: '',
  terms:  '',
};

TermsSource.propTypes = {
  onTermsChanged:  PropTypes.func.isRequired,
  onSourceChanged: PropTypes.func.isRequired,
  source:          PropTypes.string,
  terms:           PropTypes.string,
};

export default connect(null, null)(TermsSource);
